import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegrationErpService {
    /** Evento executado após exportar o pedido para o ERP */
    afterExportOneErp = new Subject<number>();

    /** Emite o evento de finalização da integração de um pedido com o ERP */
    emitAfterExportOneErp(idPedido: number) {
        this.afterExportOneErp?.next(idPedido);
    }
}
